import React from "react";
import { Text } from "components";
import QueueRow from "./QueueRow";

const COLUMNS = ["Title", "Status", "Last touched", "Clues", "Actions"];

/** Dense list view (PRD §9). Same data as the grid, tabular. */
const QueueTable = ({ games, buildActions, emptyMessage }) => {
  if (games.length === 0) {
    return (
      <div className="da-queue">
        <div className="da-grid-empty">
          <Text variant="body" tone="muted">
            {emptyMessage}
          </Text>
        </div>
      </div>
    );
  }

  return (
    <div className="da-queue" role="table">
      <div className="da-q-head" role="row">
        {COLUMNS.map((c) => (
          <div key={c} role="columnheader">
            {c}
          </div>
        ))}
      </div>
      {games.map((game) => (
        <QueueRow key={game.id} game={game} actions={buildActions(game)} />
      ))}
    </div>
  );
};

export default QueueTable;
